import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Reinickendorf() {
  return (
    <LocationPageTemplate
      page={{
        location: "Reinickendorf",
        locationSlug: "reinickendorf",
        keyword: "Haushaltsauflösung Reinickendorf",
        metaTitle:
          "Haushaltsauflösung Reinickendorf | Festpreis & Termin in 48h",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Reinickendorf. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Reinickendorf – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb008498c10f70b242.jpg",
        localIntro: (
          <>
            <p>
              Der Bezirk Reinickendorf im Nordwesten Berlins vereint städtisches
              Leben mit grünen Vorstadtidyllen. Von den dichter bebauten
              Ortsteilen wie dem Märkischen Viertel oder Wedding-nahen Gebieten
              bis hin zu den von Einfamilienhäusern und Villen geprägten
              Vierteln wie Frohnau, Hermsdorf oder Heiligensee – die
              Anforderungen an eine Entrümpelung sind hier sehr unterschiedlich.
            </p>
            <p>
              In den Wohnblocks des Märkischen Viertels sind die Wege zum Aufzug
              und die Koordination mit der Hausverwaltung oft wichtig. In den
              nördlichen Ortsteilen geht es hingegen häufig um die Räumung
              kompletter Grundstücke, inklusive großer Keller, Dachböden und
              Garagen.
            </p>
            <p>
              Wir kennen die vielfältigen Strukturen in Reinickendorf genau und
              passen unsere Vorgehensweise individuell an Ihr Objekt an, um eine
              reibungslose und schnelle Haushaltsauflösung zu gewährleisten.
            </p>
          </>
        ),
        trustText:
          "Ob eine Wohnung im Märkischen Viertel oder ein Einfamilienhaus in Frohnau – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Sehr gute Arbeit bei der Auflösung der Wohnung meiner Mutter in Tegel. Das Team war pünktlich und sehr freundlich.",
        challengesText: (
          <>
            <p>
              In den städtischeren Bereichen Reinickendorfs kümmern wir uns
              zuverlässig um die Einrichtung von Halteverbotszonen, um kurze
              Wege beim Abtransport zu sichern und die Nachbarschaft nicht
              unnötig zu belasten.
            </p>
            <p>
              Bei großen Objekten in Heiligensee oder Frohnau bringen wir
              ausreichend Kapazitäten mit, um auch umfangreiche Räumungen zügig
              abzuschließen. Die fachgerechte Trennung und Entsorgung aller
              Materialien auf zertifizierten Höfen ist dabei immer inklusive.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Professionell, schnell und ein fairer Festpreis. Die Wohnung in Wittenau wurde besenrein übergeben.",
            author: "Kunde aus Wittenau",
          },
          {
            text: "Ich musste mich um nichts kümmern. Das Team hat alles selbstständig und sehr ordentlich erledigt.",
            author: "Kundin aus Hermsdorf",
          },
          {
            text: "Sehr diskrete und respektvolle Räumung des Hauses. Vielen Dank für die Unterstützung.",
            author: "Familie aus Frohnau",
          },
        ],
        neighbors: [
          { name: "Pankow", slug: "pankow" },
          { name: "Spandau", slug: "spandau" },
          { name: "Oberhavel", slug: "oberhavel" },
        ],
        faqs: [
          {
            q: "Räumen Sie auch Wohnungen im Märkischen Viertel?",
            a: "Ja, wir sind im gesamten Bezirk Reinickendorf im Einsatz, auch in den großen Wohnanlagen.",
          },
          {
            q: "Was kostet eine Haushaltsauflösung in Reinickendorf?",
            a: "Die Kosten hängen vom Aufwand ab. Nach einer kostenlosen Besichtigung erhalten Sie von uns einen verbindlichen Festpreis.",
          },
          {
            q: "Beantragen Sie die Halteverbotszone selbst?",
            a: "Ja, wir kümmern uns um die komplette Abwicklung mit dem Bezirksamt und stellen die Schilder rechtzeitig auf.",
          },
          {
            q: "Verrechnen Sie auch Wertgegenstände?",
            a: "Ja, gut erhaltene Möbel oder Antiquitäten können wir bei der Besichtigung fair bewerten und vom Preis abziehen.",
          },
        ],
      }}
    />
  );
}
